import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "release-notes"
    }}>{`Release notes`}</h1>
    <h2 {...{
      "id": "march-28-2025"
    }}>{`March 28, 2025`}</h2>
    <h3 {...{
      "id": "react-native-edge-700"
    }}>{`React Native Edge 7.0.0`}</h3>
    <ul>
      <li parentName="ul">{`Updated to use BOM `}<a parentName="li" {...{
          "href": "https://central.sonatype.com/artifact/com.adobe.marketing.mobile/sdk-bom"
        }}>{`(Bill of Materials)`}</a>{` for Android SDK dependencies.`}</li>
    </ul>
    <h2 {...{
      "id": "march-4-2025"
    }}>{`March 4, 2025`}</h2>
    <h3 {...{
      "id": "flutter-edge-500"
    }}>{`Flutter Edge 5.0.0`}</h3>
    <ul>
      <li parentName="ul">{`Update to use BOM `}<a parentName="li" {...{
          "href": "https://central.sonatype.com/artifact/com.adobe.marketing.mobile/sdk-bom"
        }}>{`(Bill of Materials)`}</a>{` for Android SDK dependencies.`}</li>
      <li parentName="ul">{`Update tests to handle the deprecation warning for `}<inlineCode parentName="li">{`setMockMethodCallHandler`}</inlineCode>{`.`}</li>
    </ul>
    <h2 {...{
      "id": "february-25-2025"
    }}>{`February 25, 2025`}</h2>
    <h3 {...{
      "id": "android-edge-302"
    }}>{`Android Edge 3.0.2`}</h3>
    <ul>
      <li parentName="ul">{`Added support for recoverable error codes from Edge Network.`}</li>
    </ul>
    <h2 {...{
      "id": "february-10-2025"
    }}>{`February 10, 2025`}</h2>
    <h3 {...{
      "id": "android-edge-301"
    }}>{`Android Edge 3.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Added support for the new `}<inlineCode parentName="li">{`MobileCore.initialize`}</inlineCode>{` API introduced in Core.`}</li>
    </ul>
    <h2 {...{
      "id": "october-16-2024"
    }}>{`October 16, 2024`}</h2>
    <h3 {...{
      "id": "ios-edge-503"
    }}>{`iOS Edge 5.0.3`}</h3>
    <ul>
      <li parentName="ul">{`Adds 507 as recoverable error code and applies valid retry-after timeout values on next retry if provided on the response, otherwise applies default timeout.`}</li>
    </ul>
    <h2 {...{
      "id": "june-6-2024"
    }}>{`June 6, 2024`}</h2>
    <h3 {...{
      "id": "react-native-edge-602"
    }}>{`React Native Edge 6.0.2`}</h3>
    <ul>
      <li parentName="ul">{`Updated typescript files to support strict null checks.`}</li>
    </ul>
    <h2 {...{
      "id": "may-28-2024"
    }}>{`May 28, 2024`}</h2>
    <h3 {...{
      "id": "ios-edge-502"
    }}>{`iOS Edge 5.0.2`}</h3>
    <ul>
      <li parentName="ul">{`Fixed an issue in Edge hit processor and now it retries hits on recoverable URLErrors shared by Mobile Core.`}</li>
    </ul>
    <h2 {...{
      "id": "may-13-2024"
    }}>{`May 13, 2024`}</h2>
    <h3 {...{
      "id": "flutter-edge-410"
    }}>{`Flutter Edge 4.1.0`}</h3>
    <ul>
      <li parentName="ul">{`Added support to customize datastream configurations on a per-event basis using the sendEvent API.`}</li>
      <li parentName="ul">{`Update environment dependencies in pubspec.`}</li>
    </ul>
    <h2 {...{
      "id": "may-2-2024"
    }}>{`May 2, 2024`}</h2>
    <h3 {...{
      "id": "ios-edge-501"
    }}>{`iOS Edge 5.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Edge requests now retrieve the configuration state at the time the requests are queued, instead of at the time the requests are sent.`}</li>
    </ul>
    <h2 {...{
      "id": "april-24-2024"
    }}>{`April 24, 2024`}</h2>
    <h3 {...{
      "id": "react-native-edge-601"
    }}>{`React Native Edge 6.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Added namespace support to the Android module.`}</li>
    </ul>
    <h2 {...{
      "id": "april-23-2024"
    }}>{`April 23, 2024`}</h2>
    <h3 {...{
      "id": "flutter-edge-401"
    }}>{`Flutter Edge 4.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Added namespace support to the Android module.`}</li>
    </ul>
    <h2 {...{
      "id": "april-16-2024"
    }}>{`April 16, 2024`}</h2>
    <h3 {...{
      "id": "flutter-edge-400"
    }}>{`Flutter Edge 4.0.0`}</h3>
    <p>{`Major version update for `}<a parentName="p" {...{
        "href": "https://github.com/adobe/aepsdk_flutter/tree/main/plugins/flutter_aepedge"
      }}>{`Edge Network`}</a>{` for Adobe Experience Platform Flutter plugin compatible with Flutter Core 4.0.0. The current release includes the following changes:`}</p>
    <ul>
      <li parentName="ul">{`Updated to use Experience Platform Android `}<inlineCode parentName="li">{`3.x`}</inlineCode>{` SDKs.`}</li>
      <li parentName="ul">{`Updated to use Experience Platform iOS `}<inlineCode parentName="li">{`5.x`}</inlineCode>{` SDKs.`}</li>
    </ul>
    <h2 {...{
      "id": "april-12-2024"
    }}>{`April 12, 2024`}</h2>
    <h3 {...{
      "id": "react-native-edge-600"
    }}>{`React Native Edge 6.0.0`}</h3>
    <p>{`Major version update for `}<a parentName="p" {...{
        "href": "https://github.com/adobe/aepsdk-react-native/tree/main/packages/edge"
      }}>{`Edge Network`}</a>{` for Adobe Experience Platform React Native Library compatible with React Native Core 6.0.0. The current release includes the following changes:`}</p>
    <ul>
      <li parentName="ul">{`Updated to use Experience Platform Android `}<inlineCode parentName="li">{`3.x`}</inlineCode>{` SDKs.`}</li>
      <li parentName="ul">{`Updated to use Experience Platform iOS `}<inlineCode parentName="li">{`5.x`}</inlineCode>{` SDKs.`}</li>
    </ul>
    <h2 {...{
      "id": "april-2-2024"
    }}>{`April 2, 2024`}</h2>
    <h3 {...{
      "id": "android-edge-300"
    }}>{`Android Edge 3.0.0`}</h3>
    <p>{`Major version update for `}<a parentName="p" {...{
        "href": "./index.md"
      }}>{`Edge Network`}</a>{` Adobe Experience Platform Mobile SDKs on Android compatible with Mobile Core 3.0.0. The current release includes the following changes:`}</p>
    <ul>
      <li parentName="ul">{`Updated the minimum supported Android API level to 21.`}</li>
      <li parentName="ul">{`Removed deprecated `}<inlineCode parentName="li">{`registerExtension`}</inlineCode>{` API. Use the MobileCore.registerExtensions() API for registering extensions and initializing the SDK instead.`}</li>
      <li parentName="ul">{`Removed deprecated function `}<inlineCode parentName="li">{`Formatters.dateToISO8601String()`}</inlineCode>{`, replaced by `}<inlineCode parentName="li">{`TimeUtils.getISO8601UTCDateWithMilliseconds()`}</inlineCode>{` in MobileCore.`}</li>
      <li parentName="ul">{`Removed deprecated function `}<inlineCode parentName="li">{`Formatters.dateToShortDateString()`}</inlineCode>{`, replaced by `}<inlineCode parentName="li">{`TimeUtils.getISO8601FullDate()`}</inlineCode>{` in MobileCore.`}</li>
      <li parentName="ul">{`Added an enhancement to prevent network retries when the device's network is offline.`}</li>
    </ul>
    <h2 {...{
      "id": "march-19-2024"
    }}>{`March 19, 2024`}</h2>
    <h3 {...{
      "id": "ios-edge-500"
    }}>{`iOS Edge 5.0.0`}</h3>
    <p>{`Major version update for `}<a parentName="p" {...{
        "href": "./index.md"
      }}>{`Edge Network`}</a>{` for Adobe Experience Platform Mobile SDKs on iOS compatible with Mobile Core 5.0.0. The current release includes the following changes:`}</p>
    <ul>
      <li parentName="ul">{`Updated the minimum supported version to iOS 12.0 and tvOS 12.0.`}</li>
      <li parentName="ul">{`Include XCFrameworks built with Xcode 15.0.1 with the GitHub release.`}</li>
    </ul>
    <h2 {...{
      "id": "march-6-2024"
    }}>{`March 6, 2024`}</h2>
    <h3 {...{
      "id": "ios-edge-431"
    }}>{`iOS Edge 4.3.1`}</h3>
    <ul>
      <li parentName="ul">{`Added max versions to Platform dependencies in podspec.`}</li>
    </ul>
    <h2 {...{
      "id": "october-27-2023"
    }}>{`October 27, 2023`}</h2>
    <h3 {...{
      "id": "ios-edge-430"
    }}>{`iOS Edge 4.3.0`}</h3>
    <ul>
      <li parentName="ul">{`Added support to customize datastream configurations on a per-event basis using the sendEvent API.`}</li>
      <li parentName="ul">{`Improved logging on connection failure.`}</li>
    </ul>
    <h3 {...{
      "id": "android-edge-240"
    }}>{`Android Edge 2.4.0`}</h3>
    <ul>
      <li parentName="ul">{`Added support to customize datastream configurations on a per-event basis using the sendEvent API.`}</li>
      <li parentName="ul">{`Improved logging on connection failure.`}</li>
    </ul>
    <h2 {...{
      "id": "september-1-2023"
    }}>{`September 1, 2023`}</h2>
    <h3 {...{
      "id": "ios-edge-420"
    }}>{`iOS Edge 4.2.0`}</h3>
    <ul>
      <li parentName="ul">{`Added the ability to request a "completion" event when making an experience event request. The `}<inlineCode parentName="li">{`contentComplete`}</inlineCode>{` event is dispatched after the request connection is closed.`}</li>
    </ul>
    <h3 {...{
      "id": "android-edge-230"
    }}>{`Android Edge 2.3.0`}</h3>
    <ul>
      <li parentName="ul">{`Added the ability to request a "completion" event when making an experience event request. The `}<inlineCode parentName="li">{`contentComplete`}</inlineCode>{` event is dispatched after the request connection is closed.`}</li>
    </ul>
    <h2 {...{
      "id": "july-21-2023"
    }}>{`July 21, 2023`}</h2>
    <h3 {...{
      "id": "ios-edge-410"
    }}>{`iOS Edge 4.1.0`}</h3>
    <ul>
      <li parentName="ul">{`Added support for chaining related events.`}</li>
      <li parentName="ul">{`Fixed location of event index when decoding network response errors and warnings.`}</li>
    </ul>
    <h3 {...{
      "id": "android-edge-220"
    }}>{`Android Edge 2.2.0`}</h3>
    <ul>
      <li parentName="ul">{`Added support for chaining related events.`}</li>
      <li parentName="ul">{`Fixed location of event index when decoding network response errors and warnings.`}</li>
    </ul>
    <h2 {...{
      "id": "june-1-2023"
    }}>{`June 1, 2023`}</h2>
    <h3 {...{
      "id": "ios-edge-400"
    }}>{`iOS Edge 4.0.0`}</h3>
    <p>{`Major version update for `}<a parentName="p" {...{
        "href": "./index.md"
      }}>{`Edge Network`}</a>{` for Adobe Experience Platform Mobile SDKs on iOS compatible with Mobile Core 4.0.0. The current release includes the following changes:`}</p>
    <ul>
      <li parentName="ul">{`Updated the minimum supported version to iOS 11.0 and tvOS 11.0.`}</li>
      <li parentName="ul">{`Include XCFrameworks built with Xcode 14.1 with the GitHub release.`}</li>
      <li parentName="ul">{`Removed deprecated class `}<inlineCode parentName="li">{`XDMFormatters`}</inlineCode>{`. Use functions `}<inlineCode parentName="li">{`getISO8601UTCDateWithMilliseconds()`}</inlineCode>{` and `}<inlineCode parentName="li">{`getISO8601FullDate()`}</inlineCode>{` in Date class extension from AEPServices module instead.`}</li>
      <li parentName="ul">{`Fixed issue where empty "payload" array was not included in events dispatched after receiving Edge Network response.`}</li>
    </ul>
    <h2 {...{
      "id": "april-11-2023"
    }}>{`April 11, 2023`}</h2>
    <h3 {...{
      "id": "android-edge-210"
    }}>{`Android Edge 2.1.0`}</h3>
    <ul>
      <li parentName="ul">{`Added support to overwrite the Edge request path with a custom path to support Edge requests for the Media Analytics service.`}</li>
    </ul>
    <h2 {...{
      "id": "february-28-2023"
    }}>{`February 28, 2023`}</h2>
    <h3 {...{
      "id": "ios-edge-160"
    }}>{`iOS Edge 1.6.0`}</h3>
    <ul>
      <li parentName="ul">{`Added tvOS support.`}</li>
    </ul>
    <h2 {...{
      "id": "february-13-2023"
    }}>{`February 13, 2023`}</h2>
    <h3 {...{
      "id": "android-edge-141"
    }}>{`Android Edge 1.4.1`}</h3>
    <ul>
      <li parentName="ul">{`Improves error handling when processing `}<inlineCode parentName="li">{`Edge.sendEvent`}</inlineCode>{` requests by catching and logging unexpected `}<inlineCode parentName="li">{`RuntimeException`}</inlineCode>{` instances thrown from within caller's `}<inlineCode parentName="li">{`EdgeCallback`}</inlineCode>{` handler implementation.`}</li>
    </ul>
    <h2 {...{
      "id": "january-31-2023"
    }}>{`January 31, 2023`}</h2>
    <h3 {...{
      "id": "android-edge-200"
    }}>{`Android Edge 2.0.0`}</h3>
    <ul>
      <li parentName="ul">{`Major version update for `}<a parentName="li" {...{
          "href": "./index.md"
        }}>{`Edge Network`}</a>{` for Adobe Experience Platform Mobile SDKs on Android compatible with Mobile Core 2.0.0. This library is now available as an `}<a parentName="li" {...{
          "href": "https://github.com/adobe/aepsdk-edge-android"
        }}>{`open source project on GitHub`}</a>{`.`}</li>
    </ul>
    <h2 {...{
      "id": "october-19-2022"
    }}>{`October 19, 2022`}</h2>
    <h3 {...{
      "id": "ios-edge-150"
    }}>{`iOS Edge 1.5.0`}</h3>
    <ul>
      <li parentName="ul">{`Adds support for persisting the location hint returned by the Edge Network for the duration of the session for an improved user experience. Includes new APIs `}<inlineCode parentName="li">{`getLocationHint`}</inlineCode>{` and `}<inlineCode parentName="li">{`setLocationHint`}</inlineCode>{` allowing hybrid applications to share the location hint across SDKs.`}</li>
    </ul>
    <h3 {...{
      "id": "android-edge-140"
    }}>{`Android Edge 1.4.0`}</h3>
    <ul>
      <li parentName="ul">{`Adds support for persisting the location hint returned by the Edge Network for the duration of the session for an improved user experience. Includes new APIs `}<inlineCode parentName="li">{`getLocationHint`}</inlineCode>{` and `}<inlineCode parentName="li">{`setLocationHint`}</inlineCode>{` allowing hybrid applications to share the location hint across SDKs.`}</li>
    </ul>
    <h2 {...{
      "id": "june-2-2022"
    }}>{`June 2, 2022`}</h2>
    <h3 {...{
      "id": "ios-edge-141"
    }}>{`iOS Edge 1.4.1`}</h3>
    <ul>
      <li parentName="ul">{`Updates the consent request to use "update" query operation in order to allow for incremental consent preferences changes.`}</li>
      <li parentName="ul">{`Internal updates to use URLComponents builder for Edge endpoints.`}</li>
    </ul>
    <h3 {...{
      "id": "android-edge-132"
    }}>{`Android Edge 1.3.2`}</h3>
    <ul>
      <li parentName="ul">{`Updates the consent request to use "update" query operation in order to allow for incremental consent preferences changes.`}</li>
      <li parentName="ul">{`Updates internal network stack to use Mobile Core's ServiceProvider Network Service, reducing overall extension code size.`}</li>
    </ul>
    <h2 {...{
      "id": "april-8-2022"
    }}>{`April 8, 2022`}</h2>
    <h3 {...{
      "id": "ios-edge-140"
    }}>{`iOS Edge 1.4.0`}</h3>
    <ul>
      <li parentName="ul">{`Updates timestamp in Experience Events to use fractional seconds.`}</li>
      <li parentName="ul">{`Deprecates APIs `}<inlineCode parentName="li">{`XDMFormatters.dateToISO8601String`}</inlineCode>{` and `}<inlineCode parentName="li">{`XDMFormatters.dateToFullDateString`}</inlineCode>{`. Use the `}<inlineCode parentName="li">{`Date`}</inlineCode>{` extension methods `}<inlineCode parentName="li">{`getISO8601UTCDateWithMilliseconds`}</inlineCode>{` and `}<inlineCode parentName="li">{`getISO8601FullDate`}</inlineCode>{` instead, provided by the AEPServices module within the AEPCore extension.`}</li>
    </ul>
    <h2 {...{
      "id": "april-1-2022"
    }}>{`April 1, 2022`}</h2>
    <h3 {...{
      "id": "adobe-experience-platform-edge-network-tag-extension-v119"
    }}>{`Adobe Experience Platform Edge Network tag extension v1.1.9`}</h3>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`UI updates for the `}<inlineCode parentName="p">{`Datastream configuration`}</inlineCode>{` section to enable the new sandbox aware datastreams. If more than one sandbox is used, a sandbox picker is displayed to allow for datastreams selection across sandboxes.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Auto-complete in the UI for default third party domain based on company name for Edge Network data collection. The domain configuration is now required, while existing configurations will continue to use the default edge.adobedc.net domain.`}</p>
      </li>
    </ul>
    <h2 {...{
      "id": "march-11-2022"
    }}>{`March 11, 2022`}</h2>
    <h3 {...{
      "id": "android-edge-131"
    }}>{`Android Edge 1.3.1`}</h3>
    <ul>
      <li parentName="ul">{`Updates timestamp in Experience Events to use fractional seconds.`}</li>
    </ul>
    <h2 {...{
      "id": "january-21-2022"
    }}>{`January 21, 2022`}</h2>
    <h3 {...{
      "id": "ios-edge-130"
    }}>{`iOS Edge 1.3.0`}</h3>
    <ul>
      <li parentName="ul">{`Allows setting a custom first-party domain that is used to interact with the mapped Adobe-provisioned Edge Network domain.`}</li>
    </ul>
    <h3 {...{
      "id": "android-edge-130"
    }}>{`Android Edge 1.3.0`}</h3>
    <ul>
      <li parentName="ul">{`Allows setting a custom first-party domain that is used to interact with the mapped Adobe-provisioned Edge Network domain.`}</li>
    </ul>
    <h2 {...{
      "id": "december-23-2021"
    }}>{`December 23, 2021`}</h2>
    <h3 {...{
      "id": "android-edge-120"
    }}>{`Android Edge 1.2.0`}</h3>
    <ul>
      <li parentName="ul">{`Adds XDM Implementation Details to each Experience Event sent to the Edge Network.`}</li>
    </ul>
    <h2 {...{
      "id": "december-22-2021"
    }}>{`December 22, 2021`}</h2>
    <h3 {...{
      "id": "ios-edge-120"
    }}>{`iOS Edge 1.2.0`}</h3>
    <ul>
      <li parentName="ul">{`Adds XDM Implementation Details to each Experience Event sent to the Edge Network.`}</li>
      <li parentName="ul">{`Fixes generic network error format to conform to EdgeEventError type so they are dispatched back to the caller correctly.`}</li>
    </ul>
    <h2 {...{
      "id": "sept-3-2021"
    }}>{`Sept 3, 2021`}</h2>
    <h3 {...{
      "id": "adobe-experience-platform-edge-network-tag-extension-v1012"
    }}>{`Adobe Experience Platform Edge Network tag extension v1.0.12`}</h3>
    <ul>
      <li parentName="ul">{`New `}<inlineCode parentName="li">{`Forward to Edge Network`}</inlineCode>{` action to be used with Mobile Core Application Lifecycle events.`}</li>
    </ul>
    <h2 {...{
      "id": "sept-2-2021"
    }}>{`Sept 2, 2021`}</h2>
    <h3 {...{
      "id": "ios-edge-112"
    }}>{`iOS Edge 1.1.2`}</h3>
    <ul>
      <li parentName="ul">{`Edge Network Extension now honors the timestamp set in XDM payload of Experience Event. If no timestamp is set, then timestamp of `}<inlineCode parentName="li">{`Edge.sendEvent()`}</inlineCode>{` API call is used.`}</li>
    </ul>
    <h3 {...{
      "id": "android-edge-112"
    }}>{`Android Edge 1.1.2`}</h3>
    <ul>
      <li parentName="ul">{`Edge Network Extension now honors the timestamp set in XDM payload of Experience Event. If no timestamp is set, then timestamp of `}<inlineCode parentName="li">{`Edge.sendEvent()`}</inlineCode>{` API call is used.`}</li>
    </ul>
    <h2 {...{
      "id": "june-10-2021"
    }}>{`June 10, 2021`}</h2>
    <h3 {...{
      "id": "ios-edge-111"
    }}>{`iOS Edge 1.1.1`}</h3>
    <ul>
      <li parentName="ul">{`Development testing enhancements for Experience Edge.`}</li>
    </ul>
    <h3 {...{
      "id": "android-edge-111"
    }}>{`Android Edge 1.1.1`}</h3>
    <ul>
      <li parentName="ul">{`Adds support for events persistence for use-cases with low network connectivity or unexpected network errors.`}</li>
      <li parentName="ul">{`Development testing enhancements for Experience Edge.`}</li>
    </ul>
    <p>{`This SDK is compatible with Android Core 1.8.2 and above.`}</p>
    <h2 {...{
      "id": "april-8-2021"
    }}>{`April 8, 2021`}</h2>
    <h3 {...{
      "id": "ios-edge-110"
    }}>{`iOS Edge 1.1.0`}</h3>
    <ul>
      <li parentName="ul">{`Integration with Edge Consent 1.0.0 and collect consent preferences enforcement on requests to AEP Edge Network.`}</li>
      <li parentName="ul">{`Adds required dependency on Edge Identity 1.0.0 that brings XDM IdentityMap support for custom identifiers.`}</li>
    </ul>
    <h3 {...{
      "id": "android-edge-110"
    }}>{`Android Edge 1.1.0`}</h3>
    <ul>
      <li parentName="ul">{`Integration with Edge Consent 1.0.0 and collect consent preferences enforcement on requests to AEP Edge Network.`}</li>
      <li parentName="ul">{`Adds required dependency on Edge Identity 1.0.0 that brings XDM IdentityMap support for custom identifiers.`}</li>
    </ul>
    <h2 {...{
      "id": "january-19-2021"
    }}>{`January 19, 2021`}</h2>
    <h3 {...{
      "id": "ios-edge-100"
    }}>{`iOS Edge 1.0.0`}</h3>
    <p>{`The Adobe Experience Platform Edge Network (AEPEdge) tag extension is now available in iOS! This extension allows for sending XDM formatted data to Adobe Experience Platform and Adobe Experience Cloud solutions, by leveraging Experience Edge capabilities.`}</p>
    <p>{`The included features with this release are:`}</p>
    <ul>
      <li parentName="ul">{`Ability to create XDM Experience Events and send them to Experience Edge Network. An optional Experience Edge response callback can be registered per event.`}</li>
      <li parentName="ul">{`The XDM Experience Events can be sent to individual Adobe Experience Platform datasets when a custom dataset identifier is set at event level.`}</li>
      <li parentName="ul">{`Events persistence.`}</li>
      <li parentName="ul">{`ECID is automatically attached on each XDM Experience Event request.`}</li>
      <li parentName="ul">{`Integration with AEPAssurance extension enabling new insights in Project Griffon about the XDM Experience Event processing and XDM data validation for an improved validation and debugging experience.`}</li>
      <li parentName="ul">{`Detailed warning/error messages are available through Project Griffon UI and logs.`}</li>
    </ul>
    <p>{`Learn more about the AEP Edge extension in the open sourced `}<a parentName="p" {...{
        "href": "https://github.com/adobe/aepsdk-edge-ios"
      }}>{`adobe/aepsdk-edge-ios`}</a>{` GitHub repository. The iOS SDK is available for installation through SPM, XCFramework and Cocoapods and can be used in Swift and Objective-C applications. This SDK is compatible with latest swift AEPCore 1.0.0.`}</p>
    <h3 {...{
      "id": "android-edge-100"
    }}>{`Android Edge 1.0.0`}</h3>
    <p>{`The Adobe Experience Platform Edge Network (Edge) tag extension is now available in Android! This extension allows for sending XDM formatted data to Adobe Experience Platform and Adobe Experience Cloud solutions, by leveraging Experience Edge capabilities.`}</p>
    <p>{`The included features with this release are:`}</p>
    <ul>
      <li parentName="ul">{`Ability to create XDM Experience Events and send them to Experience Edge Network. An optional Experience Edge response callback can be registered per event.`}</li>
      <li parentName="ul">{`The XDM Experience Events can be sent to individual Adobe Experience Platform datasets when a custom dataset identifier is set at event level.`}</li>
      <li parentName="ul">{`ECID is automatically attached on each XDM Experience Event request.`}</li>
      <li parentName="ul">{`Integration with Assurance extension enabling new insights in Project Griffon about the XDM Experience Event processing and XDM data validation for an improved validation and debugging experience.`}</li>
      <li parentName="ul">{`Detailed warning/error messages are available through Project Griffon UI and logs.`}</li>
    </ul>
    <p>{`This SDK is compatible with Android Core 1.5.7 and above.`}</p>
    <h3 {...{
      "id": "adobe-experience-platform-edge-network-mobile-extension-102"
    }}>{`Adobe Experience Platform Edge Network mobile Extension 1.0.2`}</h3>
    <ul>
      <li parentName="ul">{`Selector for the Edge Configuration.`}</li>
      <li parentName="ul">{`AEP Request Event with optional XDM event type is available for tag rules.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      